import React, { useState } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import IntroSection from '../components/IntroSection';
import SpendLessStack from '../components/SpendLessStack';
import ChaptersSection from '../components/ChaptersSection';
import BenefitsSection from '../components/BenefitsSection';
import FreeGuideSection from '../components/FreeGuideSection';
import PricingSection from '../components/PricingSection';
import FAQSection from '../components/FAQSection';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      <Header />
      <HeroSection />
      <IntroSection />
      <SpendLessStack />
      <ChaptersSection />
      <BenefitsSection />
      <FreeGuideSection />
      <PricingSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default HomePage;